// ===================================================================
// 📋 TRADUÇÕES PADRONIZADAS DE STATUS
// ===================================================================

// Ícones de ação padronizados (usar em Admin, Analista, Candidato)
export const ACTION_ICONS = {
  assign: '📋',
  reassign: '🔄',
  fix: '🔧',
  view: '👁',
  analyze: '🎫',
  edit: '✏️',
  delete: '🗑️',
  copy: '📋'
};

// Status de Pagamento - Padrão unificado
export const PAYMENT_STATUS_LABELS = {
  paid: 'Pago',
  pending: 'Pendente',
  pending_exemption_not_assigned: 'Isenção Não Atribuída',
  pending_exemption_assigned: 'Isenção Atribuída',
  pending_exemption: 'Isenção em Análise',
  exempt: 'Isento',
  exempted: 'Isento',
  rejected: 'Rejeitado',
  exemption_rejected: 'Isenção Rejeitada',
  exemption_returned: 'Isenção Devolvida',
  exemption_appealed: 'Recurso de Isenção em Análise',
  exemption_appeal_approved: 'Recurso de Isenção Aprovado',
  exemption_appeal_rejected: 'Recurso de Isenção Rejeitado',
  appeal_pending_assignment: 'Recurso Pendente de Atribuição',
  appeal_assigned: 'Recurso Atribuído',
  appeal_approved: 'Recurso Aprovado',
  appeal_rejected: 'Recurso Rejeitado'
};

// Status de Atribuição - Padrão unificado
export const ASSIGNMENT_STATUS_LABELS = {
  pending: 'Pendente',
  assigned: 'Atribuído',
  analyzing: 'Em Análise',
  completed: 'Concluído',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  returned: 'Devolvido',
  reassigned: 'Reatribuído',
  not_assigned: 'Não atribuído',
  not_reassigned: 'Não reatribuído',
  pending_exemption: 'Pendente de Análise de Isenção',
  exemption_pending_assignment: 'Isenção Atribuída',
  exemption_approved: 'Pendente', // Isenção aprovada, mas pendente de atribuição para análise curricular
  exemption_rejected: 'Isenção Rejeitada',
  exemption_returned: 'Isenção Devolvida',
  exemption_appealed: 'Recurso de Isenção em Análise',
  exemption_appeal_approved: 'Recurso de Isenção Aprovado',
  exemption_appeal_rejected: 'Recurso de Isenção Rejeitado',
  appeal_pending_assignment: 'Recurso Pendente de Atribuição',
  appeal_assigned: 'Recurso Atribuído',
  appeal_approved: 'Recurso Aprovado',
  appeal_rejected: 'Recurso Rejeitado'
};

// Status de Análise - Padrão unificado
export const ANALYSIS_STATUS_LABELS = {
  pending: 'Pendente',
  assigned: 'Atribuído',
  analyzing: 'Em Análise',
  completed: 'Concluído',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  returned: 'Devolvida', // ⭐ NOVO: Análise rejeitada, mas candidato pode enviar novo documento
  analyzed: 'Analisada',
  not_analyzed: 'Não Analisada',
  exemption_pending_assignment: 'Isenção Atribuída',
  exemption_approved: 'Pendente', // Isenção aprovada, mas pendente de atribuição para análise curricular
  exemption_rejected: 'Isenção Rejeitada',
  exemption_returned: 'Isenção Devolvida',
  exemption_appealed: 'Recurso de Isenção em Análise',
  exemption_appeal_approved: 'Recurso de Isenção Aprovado',
  exemption_appeal_rejected: 'Recurso de Isenção Rejeitado',
  appeal_pending_assignment: 'Recurso Pendente de Atribuição',
  appeal_assigned: 'Recurso Atribuído',
  appeal_approved: 'Recurso Aprovado',
  appeal_rejected: 'Recurso Rejeitado'
};

// Cores padronizadas para status - Design divertido e consistente
export const STATUS_COLORS = {
  // Status de Pagamento
  paid: '#10B981', // Verde vibrante - Sucesso
  pending: '#F59E0B', // Laranja - Atenção
  pending_exemption_not_assigned: '#F59E0B', // Laranja - Aguardando atribuição
  pending_exemption_assigned: '#3B82F6', // Azul - Atribuído ao analista
  pending_exemption: '#8B5CF6', // Roxo - Analista em análise
  exempt: '#06B6D4', // Ciano - Isento
  exempted: '#06B6D4', // Ciano - Isento
  rejected: '#EF4444', // Vermelho - Erro
  exemption_rejected: '#EF4444', // Vermelho - Isenção Rejeitada
  exemption_returned: '#06B6D4', // Ciano - Isenção Devolvida
  exemption_appealed: '#8B5CF6', // Roxo - Recurso de Isenção em Análise
  exemption_appeal_approved: '#10B981', // Verde - Recurso de Isenção Aprovado
  exemption_appeal_rejected: '#EF4444', // Vermelho - Recurso de Isenção Rejeitado
  appeal_pending_assignment: '#F59E0B', // Laranja - Recurso Pendente
  appeal_assigned: '#8B5CF6', // Roxo - Recurso Atribuído
  appeal_approved: '#10B981', // Verde - Recurso Aprovado
  appeal_rejected: '#EF4444', // Vermelho - Recurso Rejeitado
  
  // Status de Atribuição/Análise
  assigned: '#3B82F6', // Azul - Atribuído
  analyzing: '#8B5CF6', // Roxo - Em processo
  completed: '#10B981', // Verde - Concluído
  approved: '#10B981', // Verde - Aprovado
  rejected: '#EF4444', // Vermelho - Rejeitado
  returned: '#06B6D4', // Ciano - Devolvida (permite novo documento)
  reassigned: '#8B5CF6', // Roxo - Reatribuído
  analyzed: '#10B981', // Verde - Analisada
  not_analyzed: '#F59E0B', // Laranja - Não Analisada
  excluded: '#6B7280', // Cinza - Excluída
  pending_exemption: '#8B5CF6', // Roxo - Processando isenção
  exemption_pending_assignment: '#8B5CF6', // Roxo - Processando
  exemption_approved: '#F59E0B', // Laranja - Pendente
  exemption_rejected: '#EF4444', // Vermelho - Rejeitado
  exemption_returned: '#06B6D4', // Ciano - Isenção Devolvida
  exemption_appealed: '#8B5CF6', // Roxo - Recurso de Isenção em Análise
  exemption_appeal_approved: '#10B981', // Verde - Recurso de Isenção Aprovado
  exemption_appeal_rejected: '#EF4444' // Vermelho - Recurso de Isenção Rejeitado
};

// Cores de fundo para badges (mais suaves)
export const STATUS_BACKGROUND_COLORS = {
  paid: '#D1FAE5', // Verde claro
  pending: '#FEF3C7', // Amarelo claro
  pending_exemption_not_assigned: '#FEF3C7', // Amarelo claro - Aguardando
  pending_exemption_assigned: '#DBEAFE', // Azul claro - Atribuído
  pending_exemption: '#F3E8FF', // Roxo claro
  exempt: '#CFFAFE', // Ciano claro
  exempted: '#CFFAFE', // Ciano claro
  rejected: '#FEE2E2', // Vermelho claro
  exemption_rejected: '#FEE2E2', // Vermelho claro - Isenção Rejeitada
  exemption_returned: '#CFFAFE', // Ciano claro - Isenção Devolvida
  exemption_appealed: '#F3E8FF', // Roxo claro - Recurso de Isenção em Análise
  exemption_appeal_approved: '#D1FAE5', // Verde claro - Recurso de Isenção Aprovado
  exemption_appeal_rejected: '#FEE2E2', // Vermelho claro - Recurso de Isenção Rejeitado
  appeal_pending_assignment: '#FEF3C7', // Amarelo claro - Recurso Pendente
  appeal_assigned: '#F3E8FF', // Roxo claro - Recurso Atribuído
  appeal_approved: '#D1FAE5', // Verde claro - Recurso Aprovado
  appeal_rejected: '#FEE2E2', // Vermelho claro - Recurso Rejeitado
  assigned: '#DBEAFE', // Azul claro
  analyzing: '#F3E8FF', // Roxo claro
  completed: '#D1FAE5', // Verde claro
  approved: '#D1FAE5', // Verde claro
  rejected: '#FEE2E2', // Vermelho claro
  returned: '#CFFAFE', // Ciano claro - Devolvida
  reassigned: '#F3E8FF', // Roxo claro - Reatribuído
  not_assigned: '#FEF3C7', // Amarelo claro - Não atribuído
  not_reassigned: '#FEF3C7', // Amarelo claro - Não reatribuído
  analyzed: '#D1FAE5', // Verde claro - Analisada
  not_analyzed: '#FEF3C7', // Amarelo claro - Não Analisada
  excluded: '#F3F4F6', // Cinza claro - Excluída
  pending_exemption: '#F3E8FF', // Roxo claro
  exemption_pending_assignment: '#F3E8FF', // Roxo claro
  exemption_approved: '#FEF3C7', // Amarelo claro
  exemption_rejected: '#FEE2E2', // Vermelho claro
  exemption_returned: '#CFFAFE', // Ciano claro - Isenção Devolvida
  exemption_appealed: '#F3E8FF', // Roxo claro - Recurso de Isenção em Análise
  exemption_appeal_approved: '#D1FAE5', // Verde claro - Recurso de Isenção Aprovado
  exemption_appeal_rejected: '#FEE2E2' // Vermelho claro - Recurso de Isenção Rejeitado
};

// Cores de texto para badges
export const STATUS_TEXT_COLORS = {
  paid: '#065F46', // Verde escuro
  pending: '#92400E', // Laranja escuro
  pending_exemption_not_assigned: '#92400E', // Laranja escuro - Aguardando
  pending_exemption_assigned: '#1E40AF', // Azul escuro - Atribuído
  pending_exemption: '#7C3AED', // Roxo escuro
  exempt: '#0E7490', // Ciano escuro
  exempted: '#0E7490', // Ciano escuro
  rejected: '#991B1B', // Vermelho escuro
  exemption_rejected: '#991B1B', // Vermelho escuro - Isenção Rejeitada
  exemption_returned: '#0E7490', // Ciano escuro - Isenção Devolvida
  exemption_appealed: '#7C3AED', // Roxo escuro - Recurso de Isenção em Análise
  exemption_appeal_approved: '#065F46', // Verde escuro - Recurso de Isenção Aprovado
  exemption_appeal_rejected: '#991B1B', // Vermelho escuro - Recurso de Isenção Rejeitado
  appeal_pending_assignment: '#92400E', // Laranja escuro - Recurso Pendente
  appeal_assigned: '#7C3AED', // Roxo escuro - Recurso Atribuído
  appeal_approved: '#065F46', // Verde escuro - Recurso Aprovado
  appeal_rejected: '#991B1B', // Vermelho escuro - Recurso Rejeitado
  assigned: '#1E40AF', // Azul escuro
  analyzing: '#7C3AED', // Roxo escuro
  completed: '#065F46', // Verde escuro
  approved: '#065F46', // Verde escuro
  rejected: '#991B1B', // Vermelho escuro
  returned: '#0E7490', // Ciano escuro - Devolvida
  reassigned: '#7C3AED', // Roxo escuro - Reatribuído
  not_assigned: '#92400E', // Laranja escuro - Não atribuído
  not_reassigned: '#92400E', // Laranja escuro - Não reatribuído
  analyzed: '#065F46', // Verde escuro - Analisada
  not_analyzed: '#92400E', // Laranja escuro - Não Analisada
  excluded: '#6B7280', // Cinza - Excluída
  pending_exemption: '#7C3AED', // Roxo escuro
  exemption_pending_assignment: '#7C3AED', // Roxo escuro
  exemption_approved: '#92400E', // Laranja escuro
  exemption_rejected: '#991B1B', // Vermelho escuro
  exemption_returned: '#0E7490', // Ciano escuro - Isenção Devolvida
  exemption_appealed: '#7C3AED', // Roxo escuro - Recurso de Isenção em Análise
  exemption_appeal_approved: '#065F46', // Verde escuro - Recurso de Isenção Aprovado
  exemption_appeal_rejected: '#991B1B' // Vermelho escuro - Recurso de Isenção Rejeitado
};

// Status de pedido de atendimento especial (modo prova) — coluna Inscritos / filas admin
export const SPECIAL_ATTENDANCE_STATUS_LABELS = {
  pending: 'Pedido pendente',
  analyzing: 'Em análise',
  approved: 'Deferido',
  rejected: 'Indeferido',
  returned: 'Devolvido ao admin',
  appealed: 'Recurso de Atendimento Especial em Análise',
  appeal_approved: 'Recurso de Atendimento Especial Aprovado',
  appeal_rejected: 'Recurso de Atendimento Especial Rejeitado',
};

// Funções utilitárias padronizadas
export const getPaymentStatusLabel = (status) => {
  return PAYMENT_STATUS_LABELS[status] || status;
};

export const getSpecialAttendanceStatusLabel = (status) => {
  const key = (status || '').toLowerCase();
  return SPECIAL_ATTENDANCE_STATUS_LABELS[key] || status;
};

export const getAssignmentStatusLabel = (status) => {
  return ASSIGNMENT_STATUS_LABELS[status] || status;
};

export const getAnalysisStatusLabel = (status) => {
  return ANALYSIS_STATUS_LABELS[status] || status;
};

export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || '#6B7280'; // Cinza padrão
};

// Estilos padronizados para badges - Design moderno e divertido
export const getStatusBadgeStyle = (status) => {
  const baseStyle = {
    padding: '6px 12px',
    borderRadius: '20px', // Mais arredondado
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  };
  
  return {
    ...baseStyle,
    backgroundColor: STATUS_BACKGROUND_COLORS[status] || '#F3F4F6',
    color: STATUS_TEXT_COLORS[status] || '#374151'
  };
};

// Padronização de botões por finalidade
export const BUTTON_STYLES = {
  // Botões de ação principal
  primary: {
    backgroundColor: '#3B82F6',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
    transition: 'all 0.2s ease'
  },
  
  // Botões de sucesso (aprovar, concluir)
  success: {
    backgroundColor: '#10B981',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(16, 185, 129, 0.3)',
    transition: 'all 0.2s ease'
  },
  
  // Botões de atribuição (padrão)
  assignment: {
    backgroundColor: '#8B5CF6',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(139, 92, 246, 0.3)',
    transition: 'all 0.2s ease'
  },
  
  // Botões de análise curricular (especial)
  curricular: {
    backgroundColor: '#06B6D4',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(6, 182, 212, 0.3)',
    transition: 'all 0.2s ease'
  },
  
  // Botões secundários
  secondary: {
    backgroundColor: '#6B7280',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(107, 114, 128, 0.3)',
    transition: 'all 0.2s ease'
  },
  
  // Botões de perigo (rejeitar, excluir)
  danger: {
    backgroundColor: '#EF4444',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(239, 68, 68, 0.3)',
    transition: 'all 0.2s ease'
  },
  
  // Botões pequenos
  small: {
    padding: '4px 8px',
    fontSize: '12px',
    borderRadius: '6px'
  }
};

// Função para obter estilo de botão padronizado
export const getButtonStyle = (type = 'primary', size = 'normal') => {
  const baseStyle = BUTTON_STYLES[type] || BUTTON_STYLES.primary;
  const sizeStyle = size === 'small' ? BUTTON_STYLES.small : {};
  
  return {
    ...baseStyle,
    ...sizeStyle
  };
};
